import { useState, useEffect } from 'react';
import { getAuthPhotoUrl } from './AuthImage';

export const photoIdentiteUrl = (userId, version) =>
  getAuthPhotoUrl(`/api/stagiaires/photo/${userId}${version ? `?v=${version}` : ''}`);

// Photo d'identité depuis la source unique serveur (PDF converti), initiales/icône en secours
export const PhotoIdentite = ({ userId, version, className, fallback = null, alt = 'Photo', testId }) => {
  const [erreur, setErreur] = useState(false);
  useEffect(() => setErreur(false), [userId, version]);
  if (!userId || erreur) return fallback;
  return (
    <img
      src={photoIdentiteUrl(userId, version)}
      alt={alt}
      className={className}
      onError={() => setErreur(true)}
      data-testid={testId}
    />
  );
};
